import React from "react";
import { withStyles } from "@material-ui/core";
import ToolTip from "../../../../common/StyledToolTip";

const styles = (theme) => ({
  metadata: {
    fontSize: "10px",
    lineHeight: "16px",
    paddingBottom: "5px",
    color: theme.chatMetadataColor,
    fontWeight: 600,
  },
});

const pickupOrProNumbersString = (array) => {
  if (array.length <= 2) {
    return <span>{` #${joinArrayElements(array)}`}</span>;
  } else {
    let newArray = [...array];
    return (
      <ToolTip title={` #${joinArrayElements(array)}`}>
        <span>
          {` #${joinArrayElements(newArray.splice(0, 2))} +${
            newArray.length
          } more`}
        </span>
      </ToolTip>
    );
  }
};

const joinArrayElements = (array) => {
  return array.join(" #");
};

const MessageMetaData = withStyles(styles)(({ metadata, classes }) => {
  return (
    <div className={classes.metadata}>
      {metadata.stopName && `@${metadata.stopName}`}
      {metadata.pickupNumbers?.length > 0 &&
        pickupOrProNumbersString(metadata.pickupNumbers)}
      {metadata.proNumbers?.length > 0 &&
        metadata.pickupNumbers?.length === 0 &&
        pickupOrProNumbersString(metadata.proNumbers)}
    </div>
  );
});

export default MessageMetaData;
